import React from "react";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../../../i18n/localizationKeys.js";
import * as PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import constants from "../../utils/constants.js";
import DurationCalendar from "./durationCalendar.jsx";

const OccurrenceFilter = ({ disabled = false, classes, minDate }) => {
  const { t } = useTranslation();
  return (
    <Box sx={classes.itemForSearchDate}>
      <Typography
        variant="body2"
        sx={{
          ...(disabled ? classes.disableColumnName : classes.columnName),
          ...classes.occurrenceColumn,
          color: '#28b6c7',
        }}
      >
        {t(localizationKeys.Occurrence_lower)}
      </Typography>
      <DurationCalendar
        minDate={minDate}
        type={constants.DURATION_TYPE.OCCURRENCE}
        disabled={disabled}
      />
    </Box>
  );
};

OccurrenceFilter.propTypes = {
  disabled: PropTypes.bool,
  classes: PropTypes.object,
  minDate: PropTypes.object,
};

export default OccurrenceFilter;
